if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const endDateAttr = this.dataset.endDate;
      const isPopup = !!this.closest('.popup-section');

      if (endDateAttr && !isPopup) {
        // Date-based mode: home page countdown with fixed end date
        this.endDate = new Date(endDateAttr).getTime();
        this.sessionBased = false;
      } else {
        // Session-based mode: popup rolling countdown (9 min)
        const SESSION_DURATION_MS = 9 * 60 * 1000;
        const SESSION_KEY = 'popup_countdown_end';
        let storedEnd = Number(sessionStorage.getItem(SESSION_KEY));
        if (!storedEnd || storedEnd <= Date.now()) {
          storedEnd = Date.now() + SESSION_DURATION_MS;
          sessionStorage.setItem(SESSION_KEY, String(storedEnd));
        }
        this.endDate = storedEnd;
        this.sessionBased = true;
      }

      if (!this.closest('.marquee-item')) {
        window.initLazyScript(this, this.init.bind(this));
      }
    }

    init() {
      if (this.sessionBased) {
        ['js-days', 'js-hours'].forEach((cls) => {
          const el = this.querySelector('.' + cls);
          if (el) {
            const item = el.closest('.countdown__item');
            if (item) item.style.display = 'none';
          }
        });
      }

      this.daysEl       = this.querySelector('.js-days .countdown__number-part');
      this.hoursPart1El = this.querySelector('.js-hours .countdown__number-part-1');
      this.hoursPart2El = this.querySelector('.js-hours .countdown__number-part-2');
      this.minsPart1El  = this.querySelector('.js-mins .countdown__number-part-1');
      this.minsPart2El  = this.querySelector('.js-mins .countdown__number-part-2');
      this.secsPart1El  = this.querySelector('.js-secs .countdown__number-part-1');
      this.secsPart2El  = this.querySelector('.js-secs .countdown__number-part-2');

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour   = 60 * this.minute;
      this.day    = 24 * this.hour;

      const dur = getComputedStyle(this).getPropertyValue('--countdown-number-transition-duration');
      if (dur) {
        this.numberTransitionDurationMS = CountdownTimer.durationToMS(dur);
        this.animated = this.numberTransitionDurationMS > 0;
      }

      if (this.animated) {
        const animateSelector = this.sessionBased
          ? '.countdown__number:is(.js-mins, .js-secs) .countdown__number-part'
          : '.countdown__number:is(.js-hours, .js-mins, .js-secs) .countdown__number-part';
        this.querySelectorAll(animateSelector).forEach((el) => {
          el.innerHTML = '';
          const cur = document.createElement('span');
          cur.className = 'countdown__number-part-current';
          cur.textContent = '0';
          const prev = document.createElement('span');
          prev.className = 'countdown__number-part-previous';
          prev.textContent = '0';
          el.append(cur, prev);
        });
      }

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
      this.setAttribute('loaded', '');
    }

    timer() {
      const diff = this.endDate - Date.now();

      if (diff <= 0) {
        clearInterval(this.interval);
        if (this.sessionBased) sessionStorage.removeItem('popup_countdown_end');
        this.setPartValue(this.daysEl,       '0', true);
        this.setPartValue(this.hoursPart1El, '0', true);
        this.setPartValue(this.hoursPart2El, '0');
        this.setPartValue(this.minsPart1El,  '0', true);
        this.setPartValue(this.minsPart2El,  '0');
        this.setPartValue(this.secsPart1El,  '0', true);
        this.setPartValue(this.secsPart2El,  '0');
        this.setAttribute('loaded', '');
        return;
      }

      if (this.sessionBased) {
        const mins = Math.floor(diff / this.minute);
        const secs = Math.floor((diff % this.minute) / this.second);
        const mm = String(mins).padStart(2, '0');
        const ss = String(secs).padStart(2, '0');
        this.setPartValue(this.minsPart1El, mm[0], true);
        this.setPartValue(this.minsPart2El, mm[1]);
        this.setPartValue(this.secsPart1El, ss[0], true);
        this.setPartValue(this.secsPart2El, ss[1]);
      } else {
        const days  = Math.floor(diff / this.day);
        const hours = Math.floor((diff % this.day) / this.hour);
        const mins  = Math.floor((diff % this.hour) / this.minute);
        const secs  = Math.floor((diff % this.minute) / this.second);
        const hh = String(hours).padStart(2, '0');
        const mm = String(mins).padStart(2, '0');
        const ss = String(secs).padStart(2, '0');
        this.setPartValue(this.daysEl,       String(days), true);
        this.setPartValue(this.hoursPart1El, hh[0], true);
        this.setPartValue(this.hoursPart2El, hh[1]);
        this.setPartValue(this.minsPart1El,  mm[0], true);
        this.setPartValue(this.minsPart2El,  mm[1]);
        this.setPartValue(this.secsPart1El,  ss[0], true);
        this.setPartValue(this.secsPart2El,  ss[1]);
      }

      this.setAttribute('loaded', '');
    }

    setPartValue(part, value, setZeroClass) {
      if (!part) return;
      if (setZeroClass) {
        part.classList.toggle('countdown__number-part--is-0', value === '0');
      }
      if (this.animated) {
        const current = part.querySelector('.countdown__number-part-current');
        if (!current) { part.textContent = value; return; }
        if (value !== current.textContent) {
          const previous = part.querySelector('.countdown__number-part-previous');
          part.classList.add('countdown__number-part--start-transition');
          previous.textContent = current.textContent;
          current.textContent = value;
          setTimeout(() => {
            requestAnimationFrame(() => part.classList.remove('countdown__number-part--start-transition'));
          }, 20);
        }
      } else {
        part.textContent = value;
      }
    }

    static durationToMS(duration) {
      if (duration.indexOf('ms') > 0) return parseInt(duration, 10);
      if (duration.indexOf('s') > 0) return parseFloat(duration) * 1000;
      throw new Error(`Duration unit not recognised: ${duration}`);
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}